import { render } from "./OrderCellTag.vue?vue&type=template&id=2aaf8836&scoped=true"
import script from "./OrderCellTag.vue?vue&type=script&lang=js"
export * from "./OrderCellTag.vue?vue&type=script&lang=js"

import "./OrderCellTag.vue?vue&type=style&index=0&id=2aaf8836&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaf8836"]])

export default __exports__